import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useWeb3React } from '@web3-react/core';
import { PointsRepository } from '../../connectors/repositories/points';
import { formatPoints } from '../../helpers/quests';

const PAGE_SIZE = 20;

export const PointsHistory = ({ refreshKey }) => {
  const { t } = useTranslation();
  const { account } = useWeb3React();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
  }, [refreshKey]);

  useEffect(() => {
    if (!account) return;
    PointsRepository.getHistory(account, page, PAGE_SIZE)
      .then((result) => {
        setTotal(result.total);
        setItems((prev) => (page === 1 ? result.items : [...prev, ...result.items]));
      })
      .catch(() => {});
  }, [account, page, refreshKey]);

  if (!items.length) {
    return <span className="text-[1.4rem] text-white-500 p-[2rem]">{t('quests.history.empty')}</span>;
  }

  return (
    <div className="flex flex-col">
      {items.map((item) => (
        <div
          key={item.id}
          className="flex items-center justify-between py-[1.4rem] px-[2rem] border-b-[0.1rem] border-solid border-white-50 last:border-b-0"
        >
          <div className="flex flex-col space-y-[0.2rem]">
            <span className="text-[1.4rem] text-white">{t(`quests.history.reasons.${item.reason}`)}</span>
            <span className="text-[1.2rem] text-white-500">{new Date(item.createdAt).toLocaleString()}</span>
          </div>
          <span className={`text-[1.6rem] font-600 ${item.amount >= 0 ? 'text-green' : 'text-[#FFAF03]'}`}>
            {item.amount >= 0 ? '+' : ''}
            {formatPoints(item.amount)} PP
          </span>
        </div>
      ))}
      {items.length < total && (
        <button
          onClick={() => setPage((p) => p + 1)}
          className="py-[1.4rem] text-[1.4rem] text-primary custom-transition hover:opacity-80"
        >
          {t('quests.history.more')}
        </button>
      )}
    </div>
  );
};
